var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('img',{attrs:{"src":require("../../../static/image/ic_area_header.png")}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.rightText.length>0)?_c('a',{staticClass:"right",on:{"click":_vm.rightClick}},[_vm._v(_vm._s(_vm.rightText))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32a8343c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/area-header.vue
// module id = null
// module chunks = 